export function mergeMetadata<T>(meta = {}): T {
  return Object.keys(meta).reduce((acc, id) => ({...acc, ...meta[id]}), {} as T);
}
